import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, combineLatest, forkJoin, from, Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap, toArray } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HighFrequency, Journey, JourneyDetails } from '../models/iotAssetsModel.data';

import { CurrentUserInfo } from '../models/currentUserInfo';
import { DataService } from './data.service';
import { ActiaMapService } from './actia-map.service';
import { TranslateService } from '@ngx-translate/core';

import { UtilsService } from './utils.service';
import { IotAssetsService } from './iotAssets.service';

@Injectable({
  providedIn: 'root'
})
export class ActiaJourneyService {


  constructor(private http: HttpClient,
    private vehicleService : IotAssetsService,
    private dataService:DataService,
   private utlService: UtilsService,
  private translate: TranslateService ,
  // private geocodingService: GeocodingService
) {}
 private apiUrl = environment.baseTsOhwUrl;

  // Subject privato per gestire internamente i dati
  private journeyListSubject = new BehaviorSubject<Journey[]>([]);

  // Observable pubblico per la lettura dall'esterno
  public journeyList$: Observable<Journey[]> = this.journeyListSubject.asObservable();

  // Proprietà pubblica per accesso diretto (opzionale)
  public get currentJourneyList(): Journey[] {
    return this.journeyListSubject.value;
  }

  /**
   * Pulisce la lista dei journey nel BehaviorSubject
   */
  public clearJourneyList(): void {
    console.log('Pulizia journey list');
    this.journeyListSubject.next([]);
  }

  // JOURNEY NEW IMPLEMENTATION
 getJourneyList(uidAssets: string[], startTime: string, endTime: string): Observable<Journey[]> {
  const url = this.apiUrl + 'v1/rt/functions/execute';
  const userInfo: CurrentUserInfo = this.dataService.getCurrentUserInfo();
  const varUtc = userInfo.user?.preferences.timezone.label || 'utc';
  const convertedStartTime = this.convertToTimezone(startTime, varUtc);
  const convertedEndTime = this.convertToTimezone(endTime, varUtc);

  const body = {
    function: 'ohw_iot.get_journey_data',
    params: [uidAssets, convertedStartTime, convertedEndTime, varUtc],
  };
  return this.http.post<any>(url, body).pipe(
    map(response => {
      if (!response.data || response.data.length === 0) {
        console.log('Risposta vuota o array vuoto', response);
        return [];
      }
      console.log('Journey list response data:', response);

    //     {
    //     "vin": "ZNZVPFYL0R1011141",
    //     "fuel": 0,
    //     "hours": "00:06:00",
    //     "offtime": 2.92,



    //     "idle_on_worked_hours": 98.38
    // },

      return response.data.map((item: any) => ({
        trip_id: item.trip_id,
       // v_id: item.v_id,
        vin: item.vin,
        hours:item.hours,
        fuel:item.fuel,
       // plate: item.plate,
       // name_customer: item.name_customer,
       // id_customer: item.id_customer,
        start_time: item.start_time,
        start_km: item.start_km,
        start_fuel: item.start_fuel,
        start_lat: item.gps_lat_start,
        start_lon: item.gps_lon_start,
        end_time: item.end_time,
        end_km: item.end_km,
        end_fuel: item.end_fuel,
        end_lat: item.gps_lat_end,
        end_lon: item.gps_lon_end,
        total_km: item.total_km,
        total_fuel_consumed: item.total_fuel_consumed,
        fuel_efficiency: item.fuel_efficiency,
        drv1: item.drv1,
        drv2: item.drv2,
        journey_duration: item.duration,
        status: item.status,
        idle_time: item.idle_time,
        keyon_duration: item.keyon_duration,
        moving_time: item.moving_time,
        parked_duration_before_next_journey: item.parked_duration_before_next_journey,
        short_parked_duration: item.short_parked_duration,
        angle_current: item.angle_current,
        addressStart: '',
        addressEnd: ''
      } as Journey));
    }),
    switchMap((journeys: Journey[]) => {
      if (journeys.length === 0) return of([]);

      return from(journeys).pipe(
        mergeMap(journey => {
          const observables: Observable<any>[] = [];
          //console.log('ZAK_ Processing journey:', journey);

          if (journey.start_lat != null && journey.start_lon != null) {
            observables.push(
              this.vehicleService.getAddressFromCoordinates(journey.start_lat, journey.start_lon).pipe(
                map(address => journey.addressStart = address)
              )
            );
          } else {
            journey.addressStart = 'N/A';
          }

          if (journey.end_lat != null && journey.end_lon != null) {
            observables.push(
              this.vehicleService.getAddressFromCoordinates(journey.end_lat, journey.end_lon).pipe(
                map(address => journey.addressEnd = address)
              )
            );
          } else {
            journey.addressEnd = 'N/A';
          }

          if (observables.length === 0) return of(journey);

          return forkJoin(observables).pipe(
            map(() => journey),
            catchError(err => {
              console.error('Errore nel recupero indirizzi per journey:', err);
              return of(journey);
            })
          );
        }, 10), // max 10 chiamate in parallelo
        toArray(),
        catchError(error => {
          console.error('Errore nella combinazione dei viaggi:', error);
          return of(journeys);
        })
      );
    }),
     // IMPORTANTE: Qui aggiungi tap per aggiornare il BehaviorSubject con il risultato finale
    map(finalJourneys => {
      // Svuota prima la lista e poi aggiorna con i nuovi dati per evitare accumulo
      console.log('Aggiornamento journey list - nuovi dati:', finalJourneys.length, 'elementi');
      this.journeyListSubject.next(finalJourneys);
      console.log('Journey list aggiornata nel subject:', finalJourneys);
      return finalJourneys;
    }),
    catchError(error => {
      console.error('Error fetching journey list:', error);
      return throwError(() => new Error('Error fetching journey data'));
    })
  );
}

   // JOURNEY NEW IMPLEMENTATION
   getJourneyDetails(uidAssets: string[],startTime:string, endTime:string): Observable<JourneyDetails[]> {
   // const url = 'http://192.168.1.208:9090/v1/rt/functions/execute';
        const url = this.apiUrl + 'v1/rt/functions/execute';
const userInfo: CurrentUserInfo = this.dataService.getCurrentUserInfo();
const varUtc = userInfo.user?.preferences.timezone.label || 'utc'; // Usa 'utc' come default se non specificato
const convertedStartTime = this.convertToTimezone(startTime, varUtc);
const convertedEndTime = this.convertToTimezone(endTime, varUtc);
    // // Recupera il token da sessionStorage
    // const token = sessionStorage.getItem('access_token');
    // if (!token) {
    //   console.error('Token non trovato in sessionStorage.');
    //   return throwError(
    //     () => new Error('Token non trovato. Effettua il login.')
    //   );
    // }

    // let body = {
    //   function: 'fleet_iot.get_positions_by_vin_and_time_window_v1',
    //   params: [
    //     uidAssets,
    //     '2025-05-08 00:00:00',
    //     '2025-05-08 23:59:59',
    //     'europe/rome',
    //   ],
    // };

        let body = {
      function: 'ohw_iot.get_positions_by_vin_and_time_window_v1',
      params: [
        uidAssets,
        convertedStartTime,
        convertedEndTime,
        varUtc,
      ],
    };

    // // Configura gli headers con il token Bearer
    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   Authorization: `Bearer ${token}`,
    // });

    // Effettua la chiamata POST
    return this.http.post<any>(url, body).pipe(
      map((response) => {
        // Extract journey details data from response
        if (!response.data || response.data.length === 0) {
          console.log('Risposta vuota o array vuoto', response);
          return []; // Ritorno array vuoto
        }


        // Map each result item to a JourneyDetails object
        //console.log('Journey details response data:', response);
        const journeyList =  response.data.map((item: any) => ({
          id: item.id,
          k: item.k,
          received_at_ms: item.received_at_ms,
          pushed_at_ms: item.pushed_at_ms,
          id_vehicle: item.id_vehicle,
          vin: item.vin,
          plate: item.plate,
          id_customer: item.id_customer,
          name_customer: item.name_customer,
          code_customer: item.code_customer,
          tstamp: item.tstamp,
          cntr: item.cntr,
          hw_model: item.hw_model,
          hw_r: item.hw_r,
          hw_sn: item.hw_sn,
          hw_imei: item.hw_imei,
          hw_ccid: item.hw_ccid,
          hw_canmap: item.hw_canmap,
          evt: item.evt,
          status: item.status,
          gps_alt_v: item.gps_alt_v,
          gps_alt_u: item.gps_alt_u,
          gps_angle_v: item.gps_angle_v,
          gps_angle_u: item.gps_angle_u,
          gps_fix: item.gps_fix,
          gps_lat: item.gps_lat,
          gps_lon: item.gps_lon,
          gps_sat: item.gps_sat,
          gps_speed_v: item.gps_speed_v,
          gps_speed_u: item.gps_speed_u,
          gps_tstamp: item.gps_tstamp,
          gps_hdop: item.gps_hdop,
          gps_heading: item.gps_heading,
          dashboard_ign: item.dashboard_ign,
          dashboard_fuel_v: item.dashboard_fuel_v,
          dashboard_fuel_v_adj: item.dashboard_fuel_v_adj,
          dashboard_fuel_u: item.dashboard_fuel_u,
          dashboard_odo_v: item.dashboard_odo_v,
          dashboard_odo_v_adj: item.dashboard_odo_v_adj,
          dashboard_odo_u: item.dashboard_odo_u,
          dashboard_speed_v: item.dashboard_speed_v,
          dashboard_speed_v_adj: item.dashboard_speed_v_adj,
          dashboard_speed_u: item.dashboard_speed_u,
          dashboard_flvl1_v: item.dashboard_flvl1_v,
          dashboard_flvl1_v_adj: item.dashboard_flvl1_v_adj,
          dashboard_flvl1_u: item.dashboard_flvl1_u,
          dashboard_flvl2_v: item.dashboard_flvl2_v,
          dashboard_flvl2_v_adj: item.dashboard_flvl2_v_adj,
          dashboard_flvl2_u: item.dashboard_flvl2_u,
          dashboard_rpm_v: item.dashboard_rpm_v,
          dashboard_rpm_v_adj: item.dashboard_rpm_v_adj,
          dashboard_rpm_u: item.dashboard_rpm_u,
          dashboard_hours_v: item.dashboard_hours_v,
          dashboard_hours_v_adj: item.dashboard_hours_v_adj,
          dashboard_hours_u: item.dashboard_hours_u,
          dashboard_adlvl_v: item.dashboard_adlvl_v,
          dashboard_adlvl_v_adj: item.dashboard_adlvl_v_adj,
          dashboard_adlvl_u: item.dashboard_adlvl_u,
          dashboard_idletime_v: item.dashboard_idletime_v,
          dashboard_idletime_v_adj: item.dashboard_idletime_v_adj,
          dashboard_idletime_u: item.dashboard_idletime_u,
          dashboard_idlefuel_v: item.dashboard_idlefuel_v,
          dashboard_idlefuel_v_adj: item.dashboard_idlefuel_v_adj,
          dashboard_idlefuel_u: item.dashboard_idlefuel_u,
          dashboard_eontime_v: item.dashboard_eontime_v,
          dashboard_eontime_v_adj: item.dashboard_eontime_v_adj,
          dashboard_eontime_u: item.dashboard_eontime_u,
          tacho_drv1: item.tacho_drv1,
          tacho_id1: item.tacho_id1,
          tacho_state1: item.tacho_state1,
          tacho_drv1_id: item.tacho_drv1_id,
          tacho_drv1_firstname: item.tacho_drv1_firstname,
          tacho_drv1_lastname: item.tacho_drv1_lastname,
          tacho_drv1_id_customer: item.tacho_drv1_id_customer,
          tacho_drv1_name_customer: item.tacho_drv1_name_customer,
          tacho_drv1_code_customer: item.tacho_drv1_code_customer,
          tacho_drv2: item.tacho_drv2,
          tacho_id2: item.tacho_id2,
          tacho_state2: item.tacho_state2,
          tacho_drv2_id: item.tacho_drv2_id,
          tacho_drv2_firstname: item.tacho_drv2_firstname,
          tacho_drv2_lastname: item.tacho_drv2_lastname,
          tacho_drv2_id_customer: item.tacho_drv2_id_customer,
          tacho_drv2_name_customer: item.tacho_drv2_name_customer,
          tacho_drv2_code_customer: item.tacho_drv2_code_customer,
          net_op: item.net_op
        } as JourneyDetails));
        return journeyList;
        //return journeyList.sort((a: { tstamp: string | number | Date; }, b: { tstamp: string | number | Date; }) => new Date(a.tstamp).getTime() - new Date(b.tstamp).getTime());
      }),
     // tap((details) => console.log('Journey details mapped:', details)),
      catchError((error) => {
        console.error('Error fetching journey details:', error);
        return of([]); // Ritorna array vuoto invece di throwError
        //return throwError(() => new Error('Error fetching journey details data'));
      })
    );
  }

  /**
 * Ottiene le posizioni correnti di veicoli tramite VIN
 * @param vins Array di Vehicle Identification Numbers
 * @returns Observable con array di posizioni dei veicoli
 */


getHighFrequencyPoints( uidAssets: string[], startTime: string, endTime: string): Observable<any[]> {
  const url = this.apiUrl + 'v1/rt/functions/execute';

  const userInfo: CurrentUserInfo = this.dataService.getCurrentUserInfo();
  const varUtc = userInfo.user?.preferences.timezone.label || 'utc';
  const convertedStartTime = this.convertToTimezone(startTime, varUtc);
  const convertedEndTime = this.convertToTimezone(endTime, varUtc);

  const body = {
    function: 'ohw_iot.get_positions_by_vin_and_time_window_hfm_v1',  // Aggiorna con il nome reale della funzione
    params:[uidAssets, convertedStartTime, convertedEndTime, varUtc],
  };

  return this.http.post<any>(url, body).pipe(
    map(response => {
      if (!response.data || response.data.length === 0) {
        console.log('Risposta vuota o array vuoto', response);
        return [];
      }

      return response.data.map((item: any) => ({
        vin: item.vin,
        tstamp: item.tstamp,
        cntr: item.cntr,
        hw_model: item.hw_model,
        status: item.status,
        gps_alt_v: item.gps_alt_v,
        gps_angle_v: item.gps_angle_v,
        gps_lat: item.gps_lat,
        gps_lon: item.gps_lon,
        gps_speed_v: item.gps_speed_v
      } as HighFrequency));
    }),
    catchError(error => {
      console.error('Error fetching vehicle positions:', error);
      return throwError(() => new Error('Error fetching vehicle position data'));
    })
  );
}



  private convertToTimezone(dateStr: string, timezone: string): string {
  try {
    // Se la data è già nel formato corretto, non fare nulla
    if (!dateStr) return dateStr;

    // Controlla se il formato include l'ora
    const hasTime = dateStr.includes(':');

    // Se non include l'ora, aggiungi 00:00:00 per la data di inizio o 23:59:59 per la data di fine
    let fullDateStr = dateStr;
    if (!hasTime) {
      // Determina se è più probabile che sia una data di inizio o fine
      // (questo è un'euristica, potresti voler usare un parametro esplicito)
      const isStartDate = dateStr.includes('00:00:00') || !dateStr.includes(' ');
      fullDateStr = dateStr + (isStartDate ? ' 00:00:00' : ' 23:59:59');
    }

    // Crea un oggetto Date
    const date = new Date(fullDateStr);

    // Formatta la data nel fuso orario specificato
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: timezone === 'utc' ? 'UTC' : timezone.replace('europe/', 'Europe/')
    }).format(date)
      .replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/, '$3-$1-$2 $4:$5:$6');
  } catch (error) {
    console.error('Error converting date to timezone:', error);
    return dateStr; // Ritorna la data originale in caso di errore
  }
}


/**
 * Recupera l'indirizzo di partenza del primo journey
 */
getStartAddress(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) {
    return 'Indirizzo non disponibile';
  }

  // Ordina i journey per trip_id se necessario
  const sortedJourneys = [...listDataJourney].sort((a, b) => a.trip_id - b.trip_id);
  const firstJourney = sortedJourneys[0];

  return firstJourney.addressStart ||
    `${firstJourney.start_lat.toFixed(6)}, ${firstJourney.start_lon.toFixed(6)}`;
}

/**
 * Recupera l'indirizzo di arrivo dell'ultimo journey
 */
getEndAddress(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) {
    return 'Indirizzo non disponibile';
  }

  // Ordina i journey per trip_id se necessario
  const sortedJourneys = [...listDataJourney].sort((a, b) => a.trip_id - b.trip_id);
  const lastJourney = sortedJourneys[sortedJourneys.length - 1];

  return lastJourney.addressEnd ||
    `${lastJourney.end_lat.toFixed(6)}, ${lastJourney.end_lon.toFixed(6)}`;
}
/**
 * Calcola il tempo di pausa tra due journey
 * @param journey Il journey corrente
 * @returns Una stringa formattata con il tempo di pausa
 */
calculatePauseTime(journey: Journey): string {
  if (!journey || !journey.parked_duration_before_next_journey) {
    return 'N/D';
  }

  // Usa direttamente il valore parked_duration_before_next_journey
  const duration = journey.parked_duration_before_next_journey;

  // Ottieni le traduzioni
  const lblDays = this.translate.instant('mapPage.days');
  const lblHours = this.translate.instant('mapPage.hours');
  const lblMinutes = this.translate.instant('mapPage.minutes');
  const lblSeconds = this.translate.instant('mapPage.seconds');

  // Gestione del formato con punto per i giorni (es. "1.15:53:44")
  if (duration.includes('.')) {
    const [daysStr, timeStr] = duration.split('.');
    const days = parseInt(daysStr);

    // Ora elabora la parte dell'orario
    const timeParts = timeStr.split(':');
    if (timeParts.length === 3) {
      const hours = parseInt(timeParts[0]);
      const minutes = parseInt(timeParts[1]);
      const seconds = parseInt(timeParts[2]);

      if (days > 0) {
        return `${days} ${lblDays} - ${hours} ${lblHours} - ${minutes} ${lblMinutes}`;
      } else if (hours > 0) {
        return `${hours} ${lblHours} - ${minutes} ${lblMinutes}`;
      } else if (minutes > 0) {
        return `${minutes} ${lblMinutes}`;
      } else {
        return `${seconds} ${lblSeconds}`;
      }
    }

    // Se il formato dopo il punto non è riconoscibile, ritorna il valore grezzo
    return duration || 'N/D';
  }

  // Gestione dei formati esistenti con i due punti
  const parts = duration.split(':');

  if (parts.length === 4) {
    // Formato con giorni: DD:HH:MM:SS
    const days = parseInt(parts[0]);
    const hours = parseInt(parts[1]);
    const minutes = parseInt(parts[2]);
    const seconds = parseInt(parts[3]);

    if (days > 0) {
      return `${days} ${lblDays} - ${hours} ${lblHours} - ${minutes} ${lblMinutes}`;
    } else if (hours > 0) {
      return `${hours} ${lblHours} - ${minutes} ${lblMinutes}`;
    } else if (minutes > 0) {
      return `${minutes} ${lblMinutes}`;
    } else {
      return `${seconds} ${lblSeconds}`;
    }
  } else if (parts.length === 3) {
    // Formato standard: HH:MM:SS
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    const seconds = parseInt(parts[2]);

    if (hours > 0) {
      return `${hours} ${lblHours} - ${minutes} ${lblMinutes}`;
    } else if (minutes > 0) {
      return `${minutes} ${lblMinutes}`;
    } else {
      return `${seconds} ${lblSeconds}`;
    }
  } else if (parts.length === 2) {
    // Formato possibile: MM:SS
    const minutes = parseInt(parts[0]);
    const seconds = parseInt(parts[1]);

    if (minutes > 0) {
      return `${minutes} ${lblMinutes}`;
    } else {
      return `${seconds} ${lblSeconds}`;
    }
  }

  // Se il formato non è riconoscibile, ritorna il valore grezzo
  return duration || 'N/D';
}
// Calcola la durata totale di tutti i viaggi
calculateTotalDuration(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return 'N/D';

  let totalSeconds = 0;

  listDataJourney.forEach(journey => {
    if (journey.journey_duration) {
      // Assumendo che journey_duration sia nel formato "HH:MM:SS"
      const parts = journey.journey_duration.split(':');
      if (parts.length === 3) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);
        totalSeconds += hours * 3600 + minutes * 60 + seconds;
      }
    }
  });

  // Converti i secondi in formato "HH:MM:SS"
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}


// Calcola la durata totale di tutti i viaggi
// calculateWorkingDuration(listDataJourney: Journey[]): string {
//   if (!listDataJourney || listDataJourney.length === 0) return 'N/D';

//   let totalSeconds = 0;

//   listDataJourney.forEach(journey => {
//     if (journey.keyon_duration) {
//       // Assumendo che journey_duration sia nel formato "HH:MM:SS"
//       const parts = journey.journey_duration.split(':');
//       if (parts.length === 3) {
//         const hours = parseInt(parts[0]);
//         const minutes = parseInt(parts[1]);
//         const seconds = parseInt(parts[2]);
//         totalSeconds += hours * 3600 + minutes * 60 + seconds;
//       }
//     }
//   });

//   // Converti i secondi in formato "HH:MM:SS"
//   const hours = Math.floor(totalSeconds / 3600);
//   const minutes = Math.floor((totalSeconds % 3600) / 60);
//   const seconds = totalSeconds % 60;

//   return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} h`;
// }

calculateWorkingDurationNew(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return 'N/D';

  let totalSeconds = 0;

  listDataJourney.forEach(journey => {
    if (journey.hours) {
      // Assumendo che hours sia nel formato "HH:MM:SS"
      const parts = journey.hours.split(':');
      if (parts.length === 3) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);
        totalSeconds += hours * 3600 + minutes * 60 + seconds;
      }
    }
  });

  // Converti i secondi in formato "HH:MM:SS"
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} h`;
}


// Calcola la distanza totale percorsa
calculateTotalDistance(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return '0';

  const totalDistance = listDataJourney.reduce((sum, journey) => {
    return sum + (journey.total_km || 0);
  }, 0);

  return this.utlService.formatNumber(totalDistance);
}

// Calcola il carburante totale consumato
calculateTotalFuel(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return '0';

  const totalFuel = listDataJourney.reduce((sum, journey) => {
    return sum + (journey.fuel || 0);
  }, 0);

  return this.utlService.formatNumber(totalFuel);
}

// Calcola l'efficienza media del carburante
// calculateAverageFuelEfficiency(listDataJourney: Journey[]): string {
//   if (!listDataJourney || listDataJourney.length === 0) return '0';

//   const totalDistance = listDataJourney.reduce((sum, journey) => {
//     return sum + (journey.total_km || 0);
//   }, 0);

//   const totalFuel = listDataJourney.reduce((sum, journey) => {
//     return sum + (journey.total_fuel_consumed || 0);
//   }, 0);

//   if (totalDistance === 0) return '0';

//   // Formula per l/100km
//   const avgEfficiency = (totalFuel / totalDistance) * 100;
//   return this.utlService.formatNumber(avgEfficiency);
// }

calculateAverageFuelEfficiencyNew(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return '0';

  let totalHours = 0;
  const totalFuel = listDataJourney.reduce((sum, journey) => {
    if (journey.hours) {
      // Converte le ore in numero decimale
      const parts = journey.hours.split(':');
      if (parts.length === 3) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);
        totalHours += hours + (minutes / 60) + (seconds / 3600);
      }
    }
    return sum + (journey.fuel || 0);
  }, 0);

  if (totalHours === 0) return '0';

  // Formula per l/h (litri per ora)
  const avgEfficiency = totalFuel / totalHours;
  return this.utlService.formatNumber(avgEfficiency);
}

// Calcola il tempo totale di movimento
calculateTotalMovingTime(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return 'N/D';

  let totalSeconds = 0;

  listDataJourney.forEach(journey => {
    if (journey.journey_duration) {
      // Assumendo che moving_time sia nel formato "HH:MM:SS"
      const parts = journey.journey_duration.split(':');
      if (parts.length === 3) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);
        totalSeconds += hours * 3600 + minutes * 60 + seconds;
      }
    }
  });

  // Converti i secondi in formato "HH:MM:SS"
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} h`;
}
// Calcola il tempo totale di stop (somma di parked_duration_before_next_journey)
calculateTotalStopTime(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return 'N/D';

  let totalSeconds = 0;

  listDataJourney.forEach(journey => {
    if (journey.parked_duration_before_next_journey) {
      // Assumendo che parked_duration_before_next_journey sia nel formato "HH:MM:SS"
      const parts = journey.parked_duration_before_next_journey ? journey.parked_duration_before_next_journey.split(':') : [];
      if (parts.length === 3) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);
        totalSeconds += hours * 3600 + minutes * 60 + seconds;
      }
    }
  });



  // Converti i secondi in formato "HH:MM:SS"
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} h`;
}

calculateTotalShortStopTime(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return 'N/D';

  let totalSeconds = 0;

  listDataJourney.forEach(journey => {
    if (journey.short_parked_duration) {
      // Assumendo che parked_duration_before_next_journey sia nel formato "HH:MM:SS"
      const parts = journey.short_parked_duration ? journey.short_parked_duration.split(':') : [];
      if (parts.length === 3) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);
        totalSeconds += hours * 3600 + minutes * 60 + seconds;
      }
    }
  });





  // Converti i secondi in formato "HH:MM:SS"
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}/h`;
}


calculateTotalIdleTime(listDataJourney: Journey[]): string {
  if (!listDataJourney || listDataJourney.length === 0) return 'N/D';

  let totalSeconds = 0;

  listDataJourney.forEach(journey => {
    if (journey.idle_time) {
      // Assumendo che parked_duration_before_next_journey sia nel formato "HH:MM:SS"
      const parts = journey.idle_time ? journey.idle_time.split(':') : [];
      if (parts.length === 3) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);
        totalSeconds += hours * 3600 + minutes * 60 + seconds;
      }
    }
  });





  // Converti i secondi in formato "HH:MM:SS"
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} h`;
}


getEndStatus(listDataJourney: Journey[]): boolean {
  // Se c'è un journey selezionato, usa il suo stato

 if (!listDataJourney || listDataJourney.length === 0) {
    return false;
  }
  // Altrimenti, controlla il percorso complessivo
  // Verifica se l'ultimo journey nella lista è IN_PROGRESS

  if (listDataJourney && listDataJourney.length > 0) {
    const lastJourney = listDataJourney[0];

    return lastJourney.status === 'IN_PROGRESS';
  }

  return false; // Default: non in corso
}

getLastJourney(listDataJourney: Journey[]) {
  if (!listDataJourney || listDataJourney.length === 0) {
    return null;
  }
 // console.log('listDataJourney LAST:', this.listDataJourney[this.listDataJourney.length - 1]);
  // Trova il journey selezionato o l'ultimo journey attivo
  return listDataJourney.find(j => j.selected) ||
         listDataJourney.find(j => j.status === 'IN_PROGRESS') ||
         listDataJourney[listDataJourney.length - 1];
}


calculateTotalDistanceValue(journeys: Journey[]): number {
  if (!journeys || journeys.length === 0) return 0;

  const totalKm = journeys.reduce((total, journey) => {
    return total + (journey.total_km || 0);
  }, 0);

  return totalKm;
}



}
